<form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
  <div class="form-group row deliveryNote">
    <div class="col-sm-2 mt-1 pr-1">
      <label class="form-control-static" i18n="@@CreateDeliveryNoteNameLabel">Name des Lieferscheins:</label>
    </div>
    <div class="col-sm-10">
      <input type="text" class="form-control" id="deliveryNoteNumber" formControlName="deliveryNoteNumber" i18n-placeholder="@@NameOfDeleveryNotePlaceholder" placeholder="Name des Lieferscheins"/>

      <div class="error">
        <em *ngIf="formService.validateControl('deliveryNoteNumber') && formService.hasError('deliveryNoteNumber', 'required')" i18n="@@DeliveryNoteNumberRequiredError">Name wird benötigt</em>
      </div>
    </div>
  </div>
</form>

<div *ngIf="tableReady">
  <app-table [table]="table"></app-table>
</div>

<div *ngIf="!tableReady" class="loading-spinner-container">
  <div class="spinner-border text-primary loading-spinner-md" role="status">
    <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
  </div>
</div>
